import {
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_TYPE_INFO,
  NOTIFICATION_TYPE_WARNING,
  NOTIFICATION_TYPE_ERROR
} from '@/consts/enums'

import id from '@/helpers/unique-id'
import Store from '@/stores/store'

export default {
  showSuccess(text, duration = 10000, dismissible = true) {
    addNotification(NOTIFICATION_TYPE_SUCCESS, text, dismissible, duration)
  },
  showInfo(text, duration = 10000, dismissible = true) {
    addNotification(NOTIFICATION_TYPE_INFO, text, dismissible, duration)
  },
  showWarning(text, duration = 10000, dismissible = true) {
    addNotification(NOTIFICATION_TYPE_WARNING, text, dismissible, duration)
  },
  showError(text, duration = 10000, dismissible = true) {
    addNotification(NOTIFICATION_TYPE_ERROR, text, dismissible, duration)
  },
  removeNotificationById: id => {
    Store.commit('removeNotificationById', id)
  },
  removeNotificationByType: type => {
    Store.commit('removeNotificationByType', type)
  },
  getNotifications: () => Store.getters.notifications
}

function addNotification(type, text, dismissible, duration) {
  const notification = {
    __typename: 'Notification',
    id: id.generate(),
    type,
    text,
    duration,
    dismissible
  }

  Store.commit('addNotification', notification)

  return notification.id
}
